import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledModalWrapper = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 30;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	background-color: rgba(17, 19, 20, 0.85);
	opacity: 0;
	transition: opacity 0.3s ease;

	&.bank-modal-enter {
		opacity: 0;
	}

	&.bank-modal-enter-active,
	&.bank-modal-enter-done,
	&.bank-modal-exit {
		opacity: 1;
	}

	&.bank-modal-exit-active {
		opacity: 0;
	}
`;

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 30px;
	width: 460px;
	padding: 30px;
	border-radius: 10px;
	background: #111314;
	box-shadow: 0 6px 80px 0 rgba(0, 0, 0, 0.5);
	border: 1px solid rgba(255, 255, 255, 0.1);
`;

const StyledModalTitle = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	${Text} {
		color: #ffffff;
		font-size: 18px;
		font-weight: 700;
	}
`;

export { StyledContainer, StyledModalTitle, StyledModalWrapper };
